import React, { useContext } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { ThemeContext } from '../../../../context/ThemeContext';
import { useTranslation } from 'react-i18next';


export default function DeleteAlert({ open, handleClose, handleDelete }) {
    const {darkMode} = useContext(ThemeContext)
    const {t} =useTranslation()
    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ color: "white", p: 1 }} className="bg-primary">
                <Typography id="symbol-details-modal" variant="body1" sx={{ color: darkMode ? "var(--white)" : "var(--white)" }} align="center" >{t("DeleteAlerts")}</Typography>
            </DialogTitle>
            <DialogContent sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Box m={3} mb={0}>
                    <Typography variant="body1" sx={{ textAlign: 'center' }} >{t('deleteText')}</Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", }}>
                <Button onClick={handleClose} variant="outlined" color="primary">{t('cancel')}</Button>
                <Button onClick={handleDelete} variant="contained" color="primary">{t('deleteBtn')}</Button>
            </DialogActions>
        </Dialog>
    )
}
